import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  processingTitle: {
    description: 'bulkPurchase.processingTitle',
    defaultMessage: 'Processing',
    id: 'dmSfMZ',
  },
  errorTitle: {
    description: 'bulkPurchase.errorTitle',
    defaultMessage: 'An Error Occurred',
    id: '2uqHdS',
  },
  genericHttpErrorContent: {
    description: 'bulkPurchase.genericHttpErrorContent',
    defaultMessage: 'Something failed unexpectedly. Please try again.',
    id: 'fMGXrt',
  },
});
